import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AssessmentRowComponent } from '../assessment-row/assessment-row.component';
import { EmrInputComponent } from "../../../../shared/emr-input/emr-input.component";
import { EmrCheckboxComponent } from "../../../../shared/emr-checkbox/emr-checkbox.component";
import { ProviderNotifiedFormGroup } from 'src/app/calvin-emr-shared/models/assessments/provider-notified.model';

@Component({
  selector: 'app-provider-notified-form',
  standalone: true,
  imports: [
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    AssessmentRowComponent,
    EmrInputComponent,
    EmrCheckboxComponent
  ],
  templateUrl: './provider-notified-form.component.html',
  styleUrls: ['./provider-notified-form.component.scss', '../assessments-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderNotifiedFormComponent {
  formGroup = input.required<ProviderNotifiedFormGroup>();
}
